import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { AssetUsers, UserModel } from "app/_models/user-model";
import { AssetUserService } from "app/_services/asset-user.service";
import { UpdateAssetUserComponent } from "./update-asset-user.component";
import { MatDialog } from "@angular/material/dialog";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { AddAssetUserComponent } from "./add-asset-user.component";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
declare const swal: any;

@Component({
  selector: "app-list-asset-users",
  templateUrl: "./list-asset-users.component.html",
  styleUrls: ["./list-asset-users.component.css"],
})
export class ListAssetUsersComponent implements OnInit {
  assetUsers: AssetUsers[];
  assetUserDetails: AssetUsers[];
  isAdminGroupUser: boolean = false;
  isLoaderResult: boolean = true;
  currentUser: UserModel;
  resultLength = 0;
  displayedColumns: string[] = [
    "icon",
    "employeeId",
    "firstName",
    "lastName",
    "email",
    "mobileNumber",
    "userStatus",
    "isDeleted",
    "edit",
    "delete",
  ];
  dataSource = new MatTableDataSource<AssetUsers>([]);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (this.dataSource != null) {
      this.dataSource.sort = value;
    }
  }

  editAssetUser: AssetUsers;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 75, 100];
  searchValue: string = "";
  pageEvent: PageEvent = { pageIndex: 0, pageSize: this.pageSize, length: 0 };
  @ViewChild("searchInput") searchInput!: ElementRef;

  constructor(
    private readonly assetUserService: AssetUserService,
    private readonly _liveAnnouncer: LiveAnnouncer,
    private readonly matDialog: MatDialog,
    public datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.dataSource = new MatTableDataSource<AssetUsers>([]);
    this.assetUsers = [];
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
    this.dataSource.filterPredicate = this.createFilter();
    this.callAssetUserDetails("", 1, this.pageSize);
  }

  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  createFilter(): (data: AssetUsers, filter: string) => boolean {
    return (data: AssetUsers, filter: string): boolean => {
      const searchTerm = filter.trim().toLowerCase();

      const valuesToSearch = [
        data.employeeId,
        data.firstName,
        data.lastName,
        data.email,
        data.mobileNumber,
        data.userStatus,
        data.isDeleted?.toString(),
      ];

      return valuesToSearch.some((value) =>
        value?.toString().toLowerCase().includes(searchTerm)
      );
    };
  }

  callAssetUserDetails(
    searchValue: string,
    pageNumber: number,
    pageSize: number
  ) {
    let model = {
      searchValue: searchValue,
      currentPage: pageNumber,
      pageSize: pageSize,
      downloadAllData: false,
    };
    this.assetUserService.getAllAssetUsers(model).subscribe(
      (data) => {
        this.isLoaderResult = false;
        if (!data.didError) {
          this.assetUsers = data.model;
          this.dataSource = new MatTableDataSource<AssetUsers>(this.assetUsers);
          this.totalRows = data.totalRecords;
          this.resultLength = this.assetUsers.length;
        } else {
          this.assetUsers = data.model;
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      },
      (error) => {
        const errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";
        this.isLoaderResult = false;
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  AddAssetUser() {
    const dialogRef = this.matDialog.open(AddAssetUserComponent, {
      width: "80%",
      disableClose: true,
      data: {
        searchValue: this.searchValue,
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.callAssetUserDetails(
          result.searchValue,
          result.pageNumber,
          result.pageSize
        );
        setTimeout(() => {}, 1500);
      }
    });
  }

  exportRecords() {
    swal({
      title: "Are you sure to do this?",
      text: "This process does not display data. It will download all records in a spreadsheet.",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Download the records.",
    }).then((result) => {
      if (result === true) {
        this.assetUserDetails = [];
        this.isLoaderResult = true;
        let model = {
          searchValue: "",
          currentPage: 0,
          pageSize: 0,
          downloadAllData: true,
        };
        this.assetUserService.getAllAssetUsers(model).subscribe(
          (results) => {
            this.isLoaderResult = false;
            if (!results.didError) {
              this.assetUserDetails = results.model;
              const workSheet = XLSX.utils.json_to_sheet(
                this.assetUserDetails.map((item) => {
                  return {
                    employeeId: item.employeeId,
                    FirstName: item.firstName,
                    LastName: item.lastName,
                    Email: item.email,
                    Mobile: item.mobileNumber,
                    Status: item.userStatus,
                    IsDeleted: item.isDeleted,
                    CreatedBy: item.createdBy,
                    CreatedOn: this.datepipe.transform(
                      item.createdOn,
                      "dd-MMM-yyyy"
                    ),
                    UpdatedBy: item.updatedBy,
                    UpdatedOn: this.datepipe.transform(
                      item.updatedOn,
                      "dd-MMM-yyyy"
                    ),
                  };
                })
              );
              const workBook: XLSX.WorkBook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workBook, workSheet, "SheetName");
              let fileName =
                "Assetusers_" +
                this.datepipe.transform(new Date(), "dd_MM_yyyy_hh_mm") +
                ".xlsx";
              XLSX.writeFile(workBook, fileName);
            } else {
              this.isLoaderResult = false;
              swal({
                title: "",
                text: results.message,
                type: "error",
                confirmButtonClass: "btn btn-info",
              });
            }
          },
          (error) => {
            const errorMessage =
              error.error?.title ??
              error.error ??
              "Something went wrong. Please contact admin.";
            this.isLoaderResult = false;
            swal({
              title: "",
              text: errorMessage,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          }
        );
      }
    });
  }

  editAssetUserDetail(e, element): void {
    this.editAssetUser = element;
    const dialogRef = this.matDialog.open(UpdateAssetUserComponent, {
      width: "90%",
      disableClose: true,
      data: {
        searchValue: this.searchValue,
        assetUserDetail: this.editAssetUser,
        pageNumber: this.paginator.pageIndex + 1,
        pageSize: this.paginator.pageSize,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.callAssetUserDetails(
          result.searchValue,
          result.pageNumber,
          result.pageSize
        );
        setTimeout(() => {}, 1500);
      }
    });
  }

  softDelete(e, element) {
    swal({
      title: "Are you sure to delete?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Delete IT!",
    }).then((result) => {
      if (result === true) {
        this.deleteAssetUser(e, element);
      }
    });
  }

  deleteAssetUser(e, element): void {
    let model = { id: element.assetUserId, updatedBy: "" };
    this.assetUserService.deleteAssetUser(model).subscribe(
      (data) => {
        this.isLoaderResult = false;
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          this.callAssetUserDetails(
            this.searchValue,
            this.paginator.pageIndex + 1,
            this.paginator.pageSize
          );
          setTimeout(() => {}, 1500);
        }
      },
      (error) => {
        this.isLoaderResult = false;
        swal({
          title: "",
          text: "Somthing went wrong. Please contact admin",
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.callAssetUserDetails(
      this.searchValue,
      this.paginator.pageIndex + 1,
      this.paginator.pageSize
    );
  }

   applyFilter(filterValue: string) {
       this.dataSource.filter = filterValue;
  }

  applySearch(searchValue: string) {
    if (searchValue.length == 0) {
      swal({
        title: "",
        text: "Please enter employeeId or Email of asset user",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
    } else {
      this.dataSource = new MatTableDataSource<AssetUsers>([]);
      this.totalRows = 0;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 25;
      this.currentPage = 0;
      this.callAssetUserDetails(
        searchValue,
        this.paginator.pageIndex + 1,
        this.paginator.pageSize
      );
    }
  }

  onClearSearch() {
   
    this.searchValue = "";

    // 3. Reset pagination and paging-related values
    this.totalRows = 0;
    this.pageSize = 25;
    this.currentPage = 0;

    // 4. Reset paginator component (safely)
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = this.pageSize;
    }

    // 5. Reset data source
    this.dataSource = new MatTableDataSource<AssetUsers>([]);
    this.assetUsers = [];

    // 6. Reload data from backend using cleared state
    this.callAssetUserDetails(
      "", // empty search
      1, // first page (1-based for your backend)
      this.pageSize
    );
  }
}
